import React from 'react';
import ReactMarkdown from 'react-markdown';
import uuid from 'uuid-random';
import rehypeRaw from 'rehype-raw';
import { Flex, FlexAlignItems, FlexBehavior, FlexDirection, FlexJustify, FlexWrap } from 'react-magma-dom';
import { StyledLessonText } from '../../Styled';
import { LessonIcon } from '../LessonIcon';
import { LessonLink } from '../LessonLink';
import { LessonPageText } from '../../../types/lessons';

interface ILessonText extends LessonPageText {
  isStandalone?: boolean;
  isTooltipShown?: boolean;
  withCustomIcon?: boolean;
  color?: string;
  linkColor?: string;
}

export const LessonText: React.FC<ILessonText> = props => {
  const { text, icon, links, isTooltipShown, isStandalone, withCustomIcon, color, linkColor } = props;

  return (
    <StyledLessonText withBorder={isStandalone} color={color}>
      <Flex
        behavior={FlexBehavior.container}
        alignItems={FlexAlignItems.flexStart}
        justify={FlexJustify.spaceBetween}
        wrap={FlexWrap.nowrap}
        testId="lesson-text"
      >
        <Flex behavior={FlexBehavior.container} direction={FlexDirection.column}>
          <ReactMarkdown rehypePlugins={[rehypeRaw as any]}>{text}</ReactMarkdown>
          {links?.map(link => <LessonLink key={uuid()} color={linkColor} {...link} />)}
        </Flex>
        {icon && (
          <LessonIcon
            icon={icon}
            color={linkColor}
            isTooltipShown={isTooltipShown}
            isCustom={isStandalone || withCustomIcon}
            margin="0 0 0 25px"
          />
        )}
      </Flex>
    </StyledLessonText>
  );
};
